import {Button} from "antd";
import styled from "styled-components";

export const OnboardingStatusButton = styled(Button)`
    width: auto;
    transition: all 3s;
    background-color: ${({status}) =>
        status === "approved"
            ? "#d4edda"
            : status === "rejected"
            ? "#f8d7da"
            : status === "candidate"
            ? "#d1ecf1"
            : status === "pending"
            ? "#fff3cd"
            : ""};

    border-color: ${({status}) =>
        status === "approved"
            ? "#28a745"
            : status === "rejected"
            ? "#dc3545"
            : status === "candidate"
            ? "#17a2b8"
            : status === "pending"
            ? "#ffc107"
            : ""};

    color: ${({status}) =>
        status === "approved"
            ? "#155724"
            : status === "rejected"
            ? "#721c24"
            : status === "candidate"
            ? "#0c5460"
            : status === "pending"
            ? "#856404"
            : ""};

    &:hover,
    &:focus {
        background-color: ${({status}) =>
            status === "approved"
                ? "#c3e6cb"
                : status === "rejected"
                ? "#f5c6cb"
                : status === "candidate"
                ? "#bee5eb"
                : status === "pending"
                ? "#ffeeba"
                : ""};

        border-color: ${({status}) =>
            status === "approved"
                ? "#218838"
                : status === "rejected"
                ? "#c82333"
                : status === "candidate"
                ? "#138496"
                : status === "pending"
                ? "#e0a800"
                : ""};

        color: ${({status}) =>
            status === "approved"
                ? "#0b2e13"
                : status === "rejected"
                ? "#491217"
                : status === "candidate"
                ? "#0a3d4c"
                : status === "pending"
                ? "#533f03"
                : ""};
    }

    & > #status-label {
        display: block;
    }

    & > #action-label {
        display: none;
    }

    &:hover > #status-label {
        display: none;
    }

    &:hover > #action-label {
        display: block;
    }
`;
